/**
 * @description Идентификатор состояния выбранных сотрудников для расчета заработной платы.
 * @type {string}
 */
export const SELECTED_EMPLOYEES = 'SELECTED_EMPLOYEES';

/**
 * @description Идентификатор состояния выбранного типа расчета для расчета заработной платы.
 * @type {string}
 */
export const SELECTED_CALCULATED_TYPE = 'SELECTED_CALCULATED_TYPE';
